import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';

import CaseDetailFields, { DetailField } from './CaseDetailFields';
import { CampaignCase } from './types';

interface Props {
  caseItem: CampaignCase;
}

export default function CaseDetailsTab({ caseItem }: Props) {
  const [isAdditionalOpen, setIsAdditionalOpen] = useState(true);

  const primaryLeft: Array<DetailField> = [
    { label: 'Case Number', value: caseItem.number },
    { label: 'Opportunity', value: caseItem.opportunity, isLink: true, isEditable: true },
    { label: 'Subject', value: caseItem.subject, isEditable: true },
    { label: 'Case Owner', value: caseItem.owner, isLink: true, isPerson: true },
  ];
  const primaryRight: Array<DetailField> = [
    { label: 'Case Record Type', value: caseItem.recordType },
    { label: 'Status', value: caseItem.status, isEditable: true },
    { label: 'Priority', value: caseItem.priority, isEditable: true },
    { label: 'Contact Name', value: caseItem.contactAccount, isEditable: true },
    { label: 'Original Case Owner', value: caseItem.originalOwner, isLink: true, isPerson: true, isEditable: true },
  ];
  const additionalLeft: Array<DetailField> = [
    { label: 'Pending Response Since', value: '', isEditable: true },
    { label: 'Awaiting Review Since', value: '', isEditable: true },
    { label: 'Time in Awaiting Review', value: '', isEditable: true },
  ];
  const additionalRight: Array<DetailField> = [
    { label: 'Case Origin', value: caseItem.origin, isEditable: true },
    { label: 'Last Follow Up On', value: '', isEditable: true },
    { label: 'Parent Case', value: '', isEditable: true },
  ];

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography
        variant="h6"
        component="h2"
        sx={{ display: 'inline-block', pb: 0.5, mb: 1, borderBottom: 3, borderColor: 'primary.main' }}
      >
        Details
      </Typography>
      <Grid container columnSpacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <CaseDetailFields fields={primaryLeft} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CaseDetailFields fields={primaryRight} />
        </Grid>
      </Grid>

      <Box sx={{ mt: 2 }}>
        <Button
          color="inherit"
          fullWidth
          aria-expanded={isAdditionalOpen}
          startIcon={
            <ExpandMoreIcon sx={{ transform: isAdditionalOpen ? 'none' : 'rotate(-90deg)' }} fontSize="small" />
          }
          onClick={() => setIsAdditionalOpen((current) => !current)}
          sx={{ justifyContent: 'flex-start', textTransform: 'none', bgcolor: 'action.hover', fontWeight: 'bold' }}
        >
          Additional Information
        </Button>
        {isAdditionalOpen && (
          <Grid container columnSpacing={4}>
            <Grid size={{ xs: 12, md: 6 }}>
              <CaseDetailFields fields={additionalLeft} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <CaseDetailFields fields={additionalRight} />
            </Grid>
          </Grid>
        )}
      </Box>
    </Paper>
  );
}
